export enum MIXPANEL_SCREENS {
  APPLICATION_REVIEW_PORTAL = "Application Review Portal",
  CAMPAIGNS = "Campaigns",
  CANDIDATE_SHEET = "Candidate Sheet",
  CATCH_ALL_PAGE = "Catch All Page",
  COMPANIES = "Companies",
  COMPANY = "Company",
  DASHBOARD = "Dashboard",
  DEMAND = "Demand Companies",
  DEMO_CONFIGS = "Demo Configs",
  SADIE_DASHBOARD = "Sadie Dashboard",
  SADIE_SIMULATOR = "Sadie Simulator",
  SADIE_VOICE_SIMULATOR = "Sadie Voice Simulator",
  EARNINGS = "Earnings",
  GLOBAL_SEARCH = "Global Search",
  HIGH_RANKED_MATCHES = "High Ranked Matches",
  JOB = "Job",
  JOB_CREATE = "Job Create",
  JOB_TRACKER = "Job Tracker",
  LEADERBOARD = "Leaderboard",
  METRICS = "Metrics",
  MOTIVATION = "Motivation",
  MY_AVIARY = "My Aviary",
  NOTIFICATIONS = "Notifications",
  ORPHANED_WORKABLE_JOBS = "Orphaned Workable Jobs",
  PLACEMENT_TRACKER = "Placement Tracker",
  JOB_HEALH = "Job Health",
  POST_SIGN_IN = "Post Sign In",
  SCREENING_IN_PROGRESS = "Screening In Progress",
  SEARCH_RESULT_SHEET = "Search Result Sheet",
  SIGN_IN = "Sign In",
  EXPLORE_IMAGES = "Explore Images",
  SIGNUP_VARIANTS = "Signup Variants",
  TASK_TRACKER = "Task Tracker",
  USERS = "Users",
  VOICE_RECORDINGS = "Voice Recordings",
}

// Where a notification interaction happened — the same components render in
// the slideout, the full page, and the global popup stack.
export enum MIXPANEL_NOTIFICATION_SURFACES {
  PAGE = "Page",
  POPUP = "Popup",
  SLIDEOUT = "Slideout",
}

// Whether a vanishing popup was closed by the staffer or timed out on its own.
export enum MIXPANEL_VANISHING_NOTIFICATION_DISMISSALS {
  ACTIVE = "actively dismissed",
  PASSIVE = "passively dismissed",
}

// How the owner reached the call-request prompt. Slack is the one that says
// they weren't in the app when the candidate asked.
export enum MIXPANEL_CALL_REQUEST_SOURCES {
  BANNER = "Banner",
  SLACK = "Slack",
}

export enum MIXPANEL_CALL_REQUEST_ACTIONS {
  ACCEPTED = "Accepted",
  CANCELLED = "Cancelled",
  VIEWED = "Viewed",
}

export enum MIXPANEL_SUBSCREENS {
  CREATE = "Create",
  EDIT = "Edit",
  LIST = "List",
  SHOW = "Show",
}
